import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmationModal';
import { getAllDealers, getDealersExceptDistrict } from '../../../api/dealersApi';
import { deleteDistrictSiteUser } from '../../../api/districtsiteuserapi';
import ExistingDealerModal from '../dealers/existingDealerModal';

export default function Dealers() {
    const navigate = useNavigate();
    const { districtId } = useParams();
    const defaultDealerObj = { id: 0, title: '', Deleted: false };
    const [loading, setLoading] = useState(true);
    const [dealers, setDealers] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [dealerToDelete, setDealerToDelete] = useState(defaultDealerObj);
    const [excludedDealers, setExcludedDealers] = useState([]);
    const [showExistingDealerModal, setShowExistingDealerModal] = useState(false);

    useEffect(() => {
        if (!loading) return;
        const fetchDealers = async () => {
            try {
                const dealersRes = await getAllDealers(districtId);
                if (dealersRes.data.success) {
                    const dealers = dealersRes.data.data;
                    setDealers(dealers);

                    const excludedRes = await getDealersExceptDistrict(districtId);
                    if (excludedRes.data.success) {
                        const currentDealerIds = new Set(dealers.map(d => d.siteUserId));
                        setExcludedDealers(
                            excludedRes.data.data.filter(dealer => !currentDealerIds.has(dealer.siteUserId))
                        );
                    }
                }
            } catch (error) {
                console.error('Error fetching dealers:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchDealers();
    }, [loading, districtId]);

    const handleAddDealer = () => {
        navigate(`/admin/districts/edit/${districtId}/dealers/create`);
    };

    const handleEditDealer = (dealerId) => {
        navigate(`/admin/districts/edit/${districtId}/dealers/${dealerId}`);
    };

    const handleDeleteTrigger = (dealer) => {
        setDealerToDelete({ ...defaultDealerObj, id: dealer?.siteUserId, title: dealer?.siteUsers?.fullName });
        setShowDeleteModal(true);
    };

    const handleDeleteDealer = async () => {
        try {
            await deleteDistrictSiteUser(districtId, dealerToDelete.id);
            setDealerToDelete(defaultDealerObj);
            setShowDeleteModal(false);
            setLoading(true);
        } catch (error) {
            console.error('Error deleting dealer:', error);
        }
    };

    const handleAddExistingDealer = () => {
        setShowExistingDealerModal(true);
    };

    const handleExistingDealerAdded = () => {
        setShowExistingDealerModal(false);
        setLoading(true);
    };

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteEvent={handleDeleteDealer}
                model={dealerToDelete}
                label="Dealer"
            />

            {/*  Existing Dealer Modal */}
            <ExistingDealerModal
                show={showExistingDealerModal}
                onClose={() => setShowExistingDealerModal(false)}
                excludedDealers={excludedDealers}
                districtId={districtId}
                onDealerAdded={handleExistingDealerAdded}
            />

            <div className="admin-tab-content">
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="admin-button" onClick={handleAddDealer}>
                        <span className="admin-button-text">Add Dealer</span>
                        <span className="admin-button-icon material-symbols-rounded" aria-hidden="true">add</span>
                    </button>

                    <button className="admin-button secondary" onClick={handleAddExistingDealer}>
                        <span className="admin-button-text">Existing Dealer</span>
                        <span className="admin-button-icon material-symbols-rounded" aria-hidden="true">person_add</span>
                    </button>
                </div>

                <div className="admin-table-wrap">
                    <table className="admin-table">
                        <tbody>
                            <tr>
                                <th className="admin-table-name-cell">Role</th>

                                <th className="admin-table-name-cell">Organization</th>

                                <th className="admin-table-name-cell">Notify</th>
                                <th className="admin-table-name-cell">Name</th>
                                <th className="admin-table-name-cell">Email</th>
                                <th className="admin-table-action-cell">&nbsp;</th>
                                <th className="admin-table-action-cell">&nbsp;</th>
                            </tr>
                            {dealers && dealers.length > 0 ? (
                                dealers.map(dealer =>
                                    <tr key={Math.floor(Math.random() * 100000)}>
                                        <td className="admin-table-name-cell">{dealer.role}</td>
                                        <td className="admin-table-name-cell">{dealer.companyName}</td>
                                        <td className="admin-table-name-cell">{dealer.notify === false ? "" : <span className='admin-table-check material-symbols-rounded'>check</span>}</td>
                                        <td className="admin-table-name-cell">{dealer?.siteUsers?.fullName}</td>
                                        <td className="admin-table-name-cell">{dealer?.siteUsers?.email}</td>
                                        <td className="admin-table-action-cell account-manager">
                                            <button className="admin-table-action" onClick={() => handleEditDealer(dealer?.siteUserId)}>
                                                <span className="material-symbols-rounded">edit</span>
                                            </button>
                                        </td>
                                        <td className="admin-table-action-cell account-manager">
                                            <button className="admin-table-action" onClick={() => handleDeleteTrigger(dealer)}>
                                                <span className="material-symbols-rounded">delete</span>
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                <tr>
                                    <td colSpan="7">No active dealers</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
